// Convert minutes to seconds
function convertToSeconds(timeStr) {
  let match = timeStr.match(/(\d+)(?:\s*(m|min|minute|s|sec|second))?/i);
  if (!match) return null;

  let amount = parseInt(match[1]);
  let unit = (match[2] || 's').toLowerCase();

  if (unit.startsWith('m')) {
    return amount * 60;
  } else {
    return amount;
  }
}

// Get total duration of each course having lessons
import getDuration from "./get-duration";
const getTotalCourseDuration = (course) => {
  let totalDuration = 0;
  if (course?.is_standalone) {
    let time = course?.time_to_read ? convertToSeconds(course?.time_to_read) : course?.video_lesson?.[0]?.duration;
    totalDuration = totalDuration + time;
  } else {
    course?.chapters?.[0]?.lessons?.lessons?.map((item) => {
      let time = item?.time_to_read ? convertToSeconds(item?.time_to_read) : item?.video_lesson?.[0]?.duration || 0;
      totalDuration = totalDuration + time;
    });
  }

  if (totalDuration) {
    return getDuration(totalDuration);
  } else {
    return "";
  }

};

export default getTotalCourseDuration;

